export const NEA_WORKFLOW = Object.freeze({

  AUTHENTICATION: "AUTHENTICATION",
  INITIALIZATION: "INITIALIZATION",

  DEMANDE_CREATE: "DEMANDE_CREATE",
  DEMANDE_UPDATE: "DEMANDE_UPDATE",
  DEMANDE_CONSULTATION: "DEMANDE_CONSULTATION",

  JUSTIFICATIF_UPLOAD: "JUSTIFICATIF_UPLOAD",
  JUSTIFICATIF_DELETE: "JUSTIFICATIF_DELETE",
  JUSTIFICATIF_EDIT: "JUSTIFICATIF_EDIT",

  DOSSIER_CONSULTATION: "DOSSIER_CONSULTATION",
  DOSSIER_MODIFICATION: "DOSSIER_MODIFICATION",

  PROFIL_CONSULTATION: "PROFIL_CONSULTATION",
  PROFIL_MODIFICATION: "PROFIL_MODIFICATION",

  NOTIFICATION_CONSULTATION: "NOTIFICATION_CONSULTATION",

  CREATION_CONTRAT_MANDAT:"CREATION_CONTRAT_MANDAT",
  PREVIEW_CONTRAT_MANDAT:"PREVIEW_CONTRAT_MANDAT",
  SIGN_CONTRAT_MANDAT:"SIGN_CONTRAT_MANDAT",
  MODIF_CONTRAT_MANDAT:"MODIF_CONTRAT_MANDAT",

  RECAP_CREATE: "RECAP_CREATE",

  LOGOUT: "LOGOUT"
});